<app-partner-detail-pro-header (getProsClicked)="handleGetPros()"></app-partner-detail-pro-header>
<app-partner-detail-pro-content [partnerId]="partnerId"></app-partner-detail-pro-content>